export default __webpack_public_path__ + "static/media/editor.92429fe3.svg";